/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/heading-has-content */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { request } from "../../../../utils/request";
import { formatCurrency, getSucursal } from "../../../../utils/helpers";
import { auth } from "../../../../utils/auth";

const PrintSingleRecibo = () => {
	const { id } = useParams();
	// const location = useLocation();

	const [recibo, setRecibo] = useState({});
	const [sucursal, setSucursal] = useState({});
	const [status, setStatus] = useState("Original");
	const [listo, setListo] = useState(false);

	const getRecibo = () => {
		request("academico/recibos/" + id).then((res) => {
			setRecibo(res.data);
			setListo(true);
		});
	};

	const onChangeStatusRecibo = (estado) => {
		setStatus(estado);
	};

	useEffect(() => {
		getRecibo();
		const sucursalInfo = JSON.parse(localStorage.getItem("user"));
		setSucursal(
			sucursalInfo.sucursales.find(
				(sucursal) => sucursal.id === getSucursal()
			)
		);
	}, []);

	// Espera a que el estado con los datos ya esté reflejado en el DOM
	// antes de abrir el diálogo de impresión.
	useEffect(() => {
		if (listo) {
			window.print();
		}
	}, [listo]);

    const estudiante = recibo.estudiante;
    const curso = recibo.estudiante?.curso;
    const reciboIngreso = recibo.reciboIngreso;
    const tutor = recibo.estudiante?.tutores[0];

    const usuario = auth.getUser();

    const detallePago = recibo.reciboIngreso?.detalle_metodo_pago || {};

    const isAbono = recibo.servicios?.length > 0 && recibo.servicios[0].monto > parseFloat(recibo.servicios[0].pivot.abonado);

	return (
		<>
			<ReciboTemplate
                sucursal={sucursal}
                recibo={recibo}
                tutor={tutor}
                status={status}
                reciboIngreso={reciboIngreso}
                curso={curso}
                estudiante={estudiante}
                detallePago={detallePago}
                usuario={usuario}
                isAbono={isAbono}
            />

            <hr style={{border: "1px dashed #ccc"}} />

			<ReciboTemplate
                sucursal={sucursal}
                recibo={recibo}
                tutor={tutor}
                status={status}
                reciboIngreso={reciboIngreso}
                curso={curso}
                estudiante={estudiante}
                detallePago={detallePago}
                usuario={usuario}
                isAbono={isAbono}
            />

			<div className="ordernar-resultados no-print">
				<div className="form-group">
					<div className="radio-btn">
						<label>
							<input
								type="radio"
								onChange={() =>
									onChangeStatusRecibo("Original")
								}
								name="orden"
								value="Original"
								defaultChecked={true}
							/>{" "}
							Original
						</label>
						<label>
							<input
								type="radio"
								onChange={() => onChangeStatusRecibo("Copia")}
								name="orden"
								value="Copia"
							/>{" "}
							Copia
						</label>
					</div>
				</div>
			</div>
		</>
	);
};

export default PrintSingleRecibo;

const ReciboTemplate = ({
    sucursal,
    recibo,
    tutor,
    status,
    reciboIngreso,
    curso,
    estudiante,
    detallePago,
    usuario,
    isAbono
}) => {
    return <div className="p-2 invoice p-t-30 recibo-print">
        <div className="clear-both info-row p-t-10 d-sm-flex" style={{alignItems: 'flex-end'}}>
            <div className="info-block" style={{ width: "65%" }}>
                <div className="float-sm-left p-b-10 sucursal-info">
                    {sucursal.logo ? (
                        <img
                            alt="logo"
                            className="mb-2 recibo-logo"
                            src={sucursal.logo[0].url}
                            width="270px" />
                    ) : recibo.logo ? (
                        <img
                            alt="logo"
                            className="mb-2 recibo-logo"
                            src={recibo.logo[0].url}
                            width="270px" />
                    ) : (
                        <h3 style={{ lineHeight: "12px", marginBottom: "3px" }}>
                            {sucursal.nombre}
                        </h3>
                    )}
                    <div
                        className="mb-0 mb-sm-0"
                        style={{ lineHeight: "15px", fontSize: "13px" }}
                    >
                        RNC: {sucursal.rnc} TEL.:{sucursal.telefono}
                    </div>
                    <div
                        className="mb-2 mb-sm-0"
                        style={{ lineHeight: "15px", fontSize: "13px" }}
                    >
                        {sucursal.direccion}
                    </div>
                </div>
                {tutor && (<div className="row">
                    {tutor.contacto && (<div className="col"> <table>
                        <tbody id="info-block-1">
                            <tr>
                                <td width="120px" className="client-info-title text-uppercase text-right">
                                    CLIENTE:
                                </td>
                                <td style={{lineHeight: "13px",  paddingLeft: "10px"}}>
                                    {tutor.contacto.nombre}
                                </td>
                            </tr>

                            <tr>
                                <td width="120px" className="client-info-title text-uppercase text-right">
                                    RNC/CÉDULA:
                                </td>
                                <td style={{lineHeight: "13px",  paddingLeft: "10px"}}>
                                    {tutor.contacto.identificacion}
                                </td>
                            </tr>

                            <tr>
                                <td width="120px" className="client-info-title text-uppercase text-right">
                                    RESPONSABLE:
                                </td>
                                <td style={{lineHeight: "13px",  paddingLeft: "10px"}}>
                                    {tutor.contacto.encargado}
                                </td>
                            </tr>
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    Teléfono:
                                </td>
                                <td style={{ paddingLeft: "10px" }}>
                                    {tutor.telefono}
                                </td>
                            </tr>
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    Dirección:
                                </td>
                                <td
                                    style={{
                                        lineHeight: "13px",
                                        paddingLeft: "10px",
                                    }}
                                >
                                    {tutor.direccion}
                                </td>
                            </tr>
                        </tbody>
                    </table></div>)}
                    
                    <div className="col"><table>
                        <tbody id="info-block-1">
                            <tr>
                                <td
                                    width="120px"
                                    className="client-info-title text-uppercase text-right"
                                >
                                    Tutor:
                                </td>
                                <td
                                    style={{
                                        lineHeight: "13px",
                                        paddingLeft: "10px",
                                    }}
                                >
                                    {tutor.nombre} {tutor.apellido}
                                </td>
                            </tr>
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    Cédula/RNC:
                                </td>
                                <td style={{ paddingLeft: "10px" }}>
                                    {tutor.cedula} / {tutor.pivot.nfc}
                                </td>
                            </tr>
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    Teléfono:
                                </td>
                                <td style={{ paddingLeft: "10px" }}>
                                    {tutor.telefono}
                                </td>
                            </tr>
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    Dirección:
                                </td>
                                <td
                                    style={{
                                        lineHeight: "13px",
                                        paddingLeft: "10px",
                                    }}
                                >
                                    {tutor.direccion}
                                </td>
                            </tr>
                        </tbody>
                    </table></div>
                </div>)}
            </div>
            <div
                className="info-block"
            >
                <table>
                    <tbody id="info-block-2">
                        <tr>
                            <td colSpan={2} style={{ paddingLeft: "10px" }}>
                                <h3
                                    style={{
                                        fontSize: "0.9rem",
                                        textAlign: "right",
                                    }}
                                >
                                    {status} {recibo.estado === 'cancelado' ? ' - CANCELADO' : ''}
                                </h3>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <h3
                                    style={{
                                        fontSize: "0.9rem",
                                        marginBottom: "3px",
                                        paddingBottom: "10px",
                                        whiteSpace: "nowrap",
                                        paddingLeft: "50%",
                                        textAlign: "right",
                                    }}
                                >
                                    Recibo de Ingreso
                                </h3>
                            </td>
                        </tr>
                        {recibo.fecha && (
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    Fecha:
                                </td>
                                <td style={{ paddingLeft: "10px" }}>
                                    {dayjs(recibo.fecha).format(
                                        "DD/MM/YYYY"
                                    )}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className="client-info-title text-uppercase text-right">
                                No.:
                            </td>
                            <td style={{ paddingLeft: "10px" }}>
                                {recibo.numeracion}
                            </td>
                        </tr>
                        {reciboIngreso?.tipo_pago && (
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    MÉTODO DE PAGO:
                                </td>
                                <td style={{ paddingLeft: "10px", textTransform: "capitalize" }}>
                                    {reciboIngreso.tipo_pago}
                                </td>
                            </tr>
                        )}
                        {reciboIngreso?.tipo_pago === "cheque" && reciboIngreso?.detalle_metodo_pago?.num_cheque && (
                            <tr>
                                <td className="client-info-title text-uppercase text-right">
                                    NÚMERO CHEQUE:
                                </td>
                                <td style={{ paddingLeft: "10px", textTransform: "uppercase" }}>
                                    {reciboIngreso.detalle_metodo_pago.num_cheque}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className="client-info-title text-uppercase text-right">
                                Período Académico:
                            </td>
                            <td style={{ paddingLeft: "10px", textTransform: "uppercase" }}>
                                {curso?.periodoAcademico?.nombre}
                            </td>
                        </tr>
                        <tr>
                            <td className="client-info-title text-uppercase text-right">
                                Grupo:
                            </td>
                            <td style={{ paddingLeft: "10px", textTransform: "uppercase" }}>
                                {curso?.grupoPago}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <hr />
        <div className="clear-both info-row p-b-10">
            <div className="info-block" style={{ width: "65%" }}>
                <table>
                    <tbody id="info-block-1">
                        <tr>
                            <td
                                width="120px"
                                className="client-info-title text-uppercase text-right"
                            >
                                Estudiante:
                            </td>
                            <td
                                style={{
                                    lineHeight: "13px",
                                    paddingLeft: "10px",
                                }}
                            >
                                {estudiante?.nombreCompleto}
                            </td>
                        </tr>
                        <tr>
                            <td className="client-info-title text-uppercase text-right">
                                Matrícula:
                            </td>
                            <td style={{ paddingLeft: "10px" }}>
                                {estudiante?.matricula}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="info-block" style={{ width: "65%" }}>
                <table>
                    <tbody id="info-block-1">
                        <tr>
                            <td
                                width="120px"
                                className="client-info-title text-uppercase text-right"
                            >
                                Curso:
                            </td>
                            <td
                                style={{
                                    lineHeight: "13px",
                                    paddingLeft: "10px",
                                }}
                            >
                                {curso?.grado?.nombre}
                            </td>
                        </tr>
                        <tr>
                            <td className="client-info-title text-uppercase text-right">
                                Sección:
                            </td>
                            <td style={{ paddingLeft: "10px" }}>
                                {curso?.seccion?.nombre}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


        <div className="table-wrapper">
            <h3 className="table-title"></h3>
            <table className="table d-none d-sm-table">
                <thead>
                    <tr className="text-uppercase">
                        <th>Detalle</th>
                        <th className="text-right">Cuota</th>
                        {/* <th className="text-right">Monto Auspiciado</th> */}
                        {isAbono && (
                            <th className="text-right">Pendiente</th>
                        )}
                        <th className="text-right">{isAbono ? 'Abono' : 'Total'}</th>
                        {isAbono && (
                            <th className="text-right">Balance</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {recibo?.servicios?.map((servicio) => {
                        return (
                            <tr key={servicio.id}>
                                <td>
                                    <div className="text-uppercase">{servicio.nombre}</div>
                                </td>
                                <td className="text-right">
                                    {formatCurrency(servicio.monto)}
                                </td>
                                {isAbono && (
                                    <td className="text-right">{formatCurrency(servicio.pivot?.pendiente)}</td>
                                )}
                                {/* <td className="text-right"></td> */}
                                <td className="text-right">
                                    {formatCurrency(parseFloat(servicio.pivot?.abonado || servicio.monto))}
                                </td>
                                {isAbono && (
                                    <td className="text-right">{formatCurrency(parseFloat(servicio.monto - servicio.abonado))}</td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
        <div className="summary mt-sm-3">
            <div className="row justify-content-between justify-content-md-end">
                <div
                    className="col col-md-3 text-sm-right"
                    style={{
                        maxWidth: "10rem",
                        lineHeight: "14px",
                        fontWeight: "600",
                    }}
                >
                    TOTAL PAGADO
                </div>
                <div
                    className="col-2 text-right"
                    style={{
                        maxWidth: "8rem",
                        lineHeight: "14px",
                        fontWeight: "600",
                    }}
                >
                    {formatCurrency(recibo.total)}
                </div>
            </div>
        </div>

        <hr className="d-block d-sm-none mt-0 mb-4" />

        {recibo.notas && (
            <>
                <p style={{ fontWeight: "600", fontSize: "1rem" }}>
                    Notas:
                </p>
                <p
                    className="col-12 col-md-8 pl-0 mb-3"
                    style={{
                        fontSize: "1rem",
                        whiteSpace: "pre-line",
                        lineHeight: "normal",
                    }}
                >
                    {recibo.notas}
                </p>
            </>
        )}

        {recibo.plantilla?.pie_pagina && recibo.tipo_recibo === "ingreso" && (
            <div
                className="col-12 pt-5 text-center d-flex justify-content-center"
                style={{
                    fontWeight: "600",
                    fontSize: "1rem",
                    whiteSpace: "pre-line",
                    lineHeight: "normal",
                }}
            >
                <p className="text-center pie-pagina">
                    {recibo.plantilla?.pie_pagina}
                </p>
            </div>
        )}
        <div className="m-t-50">
            <table className="table">
                <thead>
                    <tr>
                        <th>Tipo</th>
                        <th>Banco</th>
                        <th>Tarjeta</th>
                        <th>Terminal</th>
                        <th>Aprob.</th>
                        <th>Monto</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="text-uppercase">{reciboIngreso?.tipo_pago}</td>
                        <td>{detallePago.banco || '--'}</td>
                        <td className="text-uppercase">{detallePago.tipo || '--'}</td>
                        <td>{detallePago.terminal_tarjeta || '--'}</td>
                        <td>{detallePago.num_aprobacion || '--'}</td>
                        <td>{formatCurrency(recibo.total)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div className="m-t-50">
            <h3
                className="col-sm-3 text-center fw-600"
                style={{ borderTop: "1px solid #000", margin: '55px auto 25px' }}
            >
                <div>Sello y Firma</div>
                <small>({usuario.nombre} {usuario.apellido})</small>
            </h3>
            <div className="col-sm-2 d-none d-sm-block"></div>
        </div>
    </div>;
}
